/**
 * PDF styling constants for report export
 * Uses Glitch branding: Cobalt (#290BD9), Montserrat font, Dark Slate text (#0f172a)
 */

export const PDF_COLORS = {
  primary: '#290BD9', // Cobalt - brand color
  text: '#0f172a', // Dark Slate - primary text
  textSecondary: '#374151', // Gray-700 - secondary text
  textMuted: '#6B7280', // Gray-500 - muted text
  border: '#E5E7EB', // Gray-200 - borders
  background: '#FFFFFF', // White - page background
} as const;

export const PDF_PAGE = {
  // A4 dimensions in points (72 DPI)
  width: 595.28,
  height: 841.89,
  margins: {
    top: 60,
    right: 40,
    bottom: 60,
    left: 40,
  },
  // Content area dimensions
  get contentWidth() {
    return this.width - this.margins.left - this.margins.right;
  },
  get contentHeight() {
    return this.height - this.margins.top - this.margins.bottom;
  },
} as const;

export const PDF_HEADER = {
  height: 40,
  logoMaxWidth: 80,
  logoMaxHeight: 28,
  lineY: 50, // Y position of header separator line
} as const;

export const PDF_FOOTER = {
  height: 30,
  lineY: 800, // Y position of footer separator line (page height - margin)
  textY: 820, // Y position of footer text
} as const;

export const PDF_TYPOGRAPHY = {
  // Font sizes in points
  h1: 20,
  h2: 16,
  h3: 14,
  body: 11,
  small: 9,
  caption: 8,

  // Line heights (multiplier)
  lineHeight: 1.4,

  // Spacing
  paragraphSpacing: 8,
  sectionSpacing: 16,
  headingSpacing: 12,
} as const;

export const PDF_CHARTS = {
  maxWidth: PDF_PAGE.contentWidth,
  defaultHeight: 200,
  minHeight: 150,
  maxHeight: 300,
  marginTop: 12,
  marginBottom: 16,
} as const;

// Helper to convert hex to RGB array for jsPDF
export function hexToRgb(hex: string): [number, number, number] {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return [0, 0, 0];
  return [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)];
}
